import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const tipoCentroCostoImporterSelectors = importerSelectors(
  'tipoCentroCosto.importer',
);

export default tipoCentroCostoImporterSelectors;
